import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__inner">
          <div className="footer__brand">
            <img src="/logo.png" alt="UrajiTech" className="footer__logo" />
            <span className="footer__name">UrajiTech</span>
          </div>
          <p className="footer__tagline">
            AI для людей — из Новосибирска, для всех.
          </p>
          <div className="footer__line" />
          <p className="footer__copy">
            © {new Date().getFullYear()} UrajiTech · Все права защищены
          </p>
        </div>
      </div>
    </footer>
  );
}
